import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { VatCodesDataGrid } from "src/components/views/erp/sales/masterData/vatCodes/VatCodesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/vatCodes")({
	staticData: { title: i18n.t("vat_codes"), legacyViewKey: "vatCodesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <VatCodesDataGrid />;
}
